module.exports = __webpack_public_path__ + "img/dp7.a51513bc.png";